export default __webpack_public_path__ + "static/media/AbliminalSustainabilityRoadmap.c16392e0.pdf";